import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import "./style.scss";

const Index = () => {
  const features = [
    "Dashboard med statistikk",
    "Tilgang på all bedriftsdata",
    "Prestasjonsoversikt",
    "Avansert listegenerering",
    "Pluss mer du kommer til å elske",
  ];

  return (
    <section className="prices-section">
      <div className="inner-prices-container">
        <Row className="all-details-row">
          <Col
            md
            xs={{ order: 2 }}
            sm={{ order: 2 }}
            lg={{ order: 1 }}
            className="description-col"
          >
            <Col className="inner-description-col">
              <h1 className="page-title">Pris for abonnement</h1>
              <p className="page-description">
                Leadfind tilbyr per dags dato bare ett abonnement, og opererer
                hittil med kun med èn fast pris per brukertilgang. Hvis du
                ønsker et pristilbud for mer enn 20 brukertilganger per selskap,
                kan du kontakte oss på{" "}
                <a href="mailto:salg@leadfind.no">salg@leadfind.no</a>. For
                andre henvendelser, benytt deg av{" "}
                <a href="mailto:kontakt@leadfind.no">kontakt@leadfind.no</a>
                <br />
                <br />
                Abonnementet betales forskuddsvis hver måned, og kan sies opp
                når som helst uten bindingstid gitt at du ikke har noe
                utestående, dersom du ikke ønsker å abonnere lenger.
              </p>
              <div className="faq-container">
                <h3 className="faq-title">Ofte stilte spørsmål</h3>
                <Row className="questions-row">
                  <Col md className="single-question">
                    <Row className="question-row">
                      <Col className="icon-col">
                        <h3 className="question-icon">
                          <i class="fad fa-question"></i>
                        </h3>
                      </Col>
                      <Col className="details-col">
                        <h5 className="question-title">
                          Blir kortet belastet umiddelbart ved starten av
                          abonnementet?
                        </h5>
                        <p className="question-answer">
                          Nei, det blir det ikke. Du vil ikke bli trukket før
                          prøveperioden er over, og du har bestemt deg for å
                          fortsette å benytte deg av tjenesten.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col md className="single-question">
                    <Row className="question-row">
                      <Col className="icon-col">
                        <h3 className="question-icon">
                          <i class="fad fa-question"></i>
                        </h3>
                      </Col>
                      <Col className="details-col">
                        <h5 className="question-title">
                          Inneholder Leadfind noen skjulte ekstrakostnader?
                        </h5>
                        <p className="question-answer">
                          Det gjør det ikke, velger du på betale for tilgang til
                          tjenesten er det ikke noe vi holder tilbake og du vil
                          få tilgang til absolutt alt.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="questions-row">
                  <Col md className="single-question">
                    <Row className="question-row">
                      <Col className="icon-col">
                        <h3 className="question-icon">
                          <i class="fad fa-question"></i>
                        </h3>
                      </Col>
                      <Col className="details-col">
                        <h5 className="question-title">
                          Er det enkelt for meg å avslutte et abonnement?
                        </h5>
                        <p className="question-answer">
                          Du kan veldig enkelt avslutte abonnementet ditt
                          gjennom Dashboardet ved å trykke på "Mitt foretak" og
                          velge "Avslutt abonnement".
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col md className="single-question">
                    <Row className="question-row">
                      <Col className="icon-col">
                        <h3 className="question-icon">
                          <i class="fad fa-question"></i>
                        </h3>
                      </Col>
                      <Col className="details-col">
                        <h5 className="question-title">
                          Kan jeg endre på antall brukertilganger ved en senere
                          anledning?
                        </h5>
                        <p className="question-answer">
                          Ja, det kan du. Dersom teamet ditt vokser kan du
                          enkelt selv opp -eller nedjustere antall og få endret
                          lisensen din etter behov.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Col>
          </Col>
          <Col
            md
            xs={{ order: 1 }}
            sm={{ order: 1 }}
            lg={{ order: 2 }}
            className="showcase-col"
          >
            <Col>
              <div className="showcase-container">
                <div className="inner-showcase-container">
                  <h2 className="showcase-icon">
                    <i class="fad fa-award"></i>
                  </h2>
                  <h3 className="showcase-title">Leadfind Standard</h3>
                  <h5 className="showcase-price">399kr pr bruker</h5>
                  <span className="showcase-description">
                    Eks. moms, per måned
                  </span>
                  <div className="features-container">
                    {features.map((feature) => (
                      <Row className="single-feature">
                        <Col className="name-col text-left my-auto">
                          <p className="feature-name">{feature}</p>
                        </Col>
                        <Col className="checkmark-col text-right my-auto">
                          <span className="feature-checkmark">
                            <i class="fad fa-check"></i>
                          </span>
                        </Col>
                      </Row>
                    ))}
                  </div>
                  <Link to="/registrer">
                    <button className="subscribe-button">
                      Start gratis prøveperiode
                    </button>
                  </Link>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Index;
